import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'landing-page';
export const PHOTOGRAPHERASSET_NAME = 'photographer-home';


export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const currentUser = getState().user.currentUser;
  const isPhotoGrapher = currentUser?.attributes?.profile?.publicData?.userRole == "photographer";

  const assetToUse = isPhotoGrapher
    ? PHOTOGRAPHERASSET_NAME
    : ASSET_NAME;
  
  const pageAsset = { landingPage: `content/pages/${assetToUse}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
